import { z } from 'zod';
import { baseOutputMetadataSchema, structuredToolOutputSchema, } from '../outputMetadata';
import { createToolSchema } from '../toolSchemaBuilder';
import { toolNameFor } from './discoveryToolNames';
export const TOOL_RESOLVE_URL_DESCRIPTION = ({ runtime, toolName, }) => {
    const readContent = toolNameFor('readContent', runtime);
    return `Tool: ${toolName}

Purpose:
Expands a Lightdash share short-link into the full URL it redirects to. Share links are opaque — this tool is the only way to see what they point at.

When to use:
- ONLY for URLs whose path is "/share/<id>" (e.g. "<host>/share/aBcD1234..."). Nothing else is a share link.
- NEVER call this for any other URL. A URL like "/projects/<uuid>/saved/<uuid>" or "/projects/<uuid>/dashboards/<uuid>" already contains its identifiers — read them directly from the path and go straight to the appropriate tool.

Usage tips:
- Read the identifiers (project uuid, chart or dashboard uuid, explore name) from the expanded URL, then use other tools (e.g. ${readContent}) to fetch the content.
- URLs that don't belong to this Lightdash instance cannot be resolved.`;
};
export const toolResolveUrlArgsSchema = createToolSchema()
    .extend({
    url: z
        .string()
        .min(1)
        .describe('The Lightdash URL to resolve, exactly as provided.'),
})
    .build();
export const toolResolveUrlStructuredContentSchema = z.discriminatedUnion('isShareLink', [
    z.object({
        isShareLink: z.literal(true),
        resolvedUrl: z
            .string()
            .describe('The full Lightdash URL the share link expands to; read the identifiers (project uuid, chart or dashboard uuid, explore name) from its path.'),
    }),
    z.object({
        url: z.string().describe('The URL that was resolved, as provided.'),
        isShareLink: z
            .literal(false)
            .describe('The URL is not a share link: its identifiers can be read directly from its path.'),
    }),
]);
export const toolResolveUrlOutputSchema = structuredToolOutputSchema({
    metadata: baseOutputMetadataSchema,
    structuredContent: toolResolveUrlStructuredContentSchema,
});
//# sourceMappingURL=toolResolveUrlArgs.js.map